import postLogin from "./postLogin";
import getUser from "./getUser";
import postLogOut from "./postLogOut";

export default {
  postLogin,
  getUser,
  postLogOut,
};
